module.exports = __webpack_public_path__ + "prod/20261104151832/img/ecology.1a964161.png";